import type { IInfluencer } from '../../../redux/buzzbridge/types';
import { ROUTES } from '../../../types/global/routes.types';
import { SITE_URL } from '../../../configurations/api/url';
import { stripLeadingAt } from '../../../utils/socialHandle';

/** Public profile slug for `/creator/:userName` share links. */
export function resolveInfluencerPublicUserName(influencer: IInfluencer): string | null {
    const fromProfile = influencer.userName?.trim();
    if (fromProfile) return stripLeadingAt(fromProfile);

    const createdBy = influencer.created_by;
    if (createdBy && typeof createdBy === 'object' && createdBy.userName?.trim()) {
        return stripLeadingAt(createdBy.userName);
    }

    const social =
        influencer.thspian?.username ||
        influencer.instagram?.username ||
        influencer.tiktok?.username ||
        influencer.youtube?.username;
    if (social?.trim()) return stripLeadingAt(social);

    return null;
}

/**
 * Absolute public creator URL that brands can open to see rate cards.
 * Uses `#rate-cards` so shared links land on that section when present.
 */
export function buildInfluencerRateCardShareUrl(influencer: IInfluencer): string | null {
    const userName = resolveInfluencerPublicUserName(influencer);
    if (!userName) return null;
    const origin =
        typeof window !== 'undefined' && window.location?.origin ? window.location.origin : SITE_URL.replace(/\/$/, '');
    const path = ROUTES.PUBLIC_CREATOR_PROFILE.replace(':userName', `@${userName}`);
    return `${origin}${path}#rate-cards`;
}
